// 018 operational settings. Provider credentials are server environment only.
import { z } from '../kernel/zod.ts';
export const SMART_PASTE_COLUMNS_QUESTION = 'smart_paste_columns';
export const SMART_PASTE_HEADERS_QUESTION = 'smart_paste_headers';
export const smartPasteQuestionVersions = {
  [SMART_PASTE_COLUMNS_QUESTION]: 'v1',
  [SMART_PASTE_HEADERS_QUESTION]: 'v1',
} as const;
export const SmartPasteSettingsSchema = z
  .strictObject({
    enabled: z.boolean().default(false),
    jevEnabled: z.boolean().default(true),
    deepseekEnabled: z.boolean().default(false),
    threshold: z.number().min(0.5).max(1).default(0.9),
    margin: z.number().min(0).max(0.5).default(0.15),
    samplesPerColumn: z.number().int().min(1).max(12).default(12),
    sampleChars: z.number().int().min(40).max(160).default(160),
    columnPayloadChars: z.number().int().min(1000).max(24000).default(24000),
    columnDeadlineMs: z.number().int().min(1000).max(20000).default(20000),
    jevTimeoutMs: z.number().int().min(500).max(5000).default(3000),
    deepseekColumnTimeoutMs: z.number().int().min(500).max(8000).default(8000),
    maxProviderCalls: z.number().int().min(1).max(3).default(3),
    concurrentAnalyses: z.number().int().min(1).max(4).default(2),
    startsPerMinute: z.number().int().min(1).max(20).default(6),
    monthlyProviderCalls: z.number().int().min(0).max(100000).default(2000),
    resultTtlSeconds: z.number().int().min(60).max(600).default(600),
    decisionRetentionDays: z.number().int().min(1).max(90).default(30),
  })
  .refine((s) => s.resultTtlSeconds * 1000 >= s.columnDeadlineMs, {
    message: 'Срок результата короче анализа',
  });
export type SmartPasteSettings = z.infer<typeof SmartPasteSettingsSchema>;
export const smartPasteDefaults: SmartPasteSettings = SmartPasteSettingsSchema.parse({});
/** Installation-only contract; absence of configured/probed provider yields manual mode. */
export const SmartPasteProviderSchema = z.discriminatedUnion('provider', [
  z.strictObject({ provider: z.literal('jev'), url: z.url(), model: z.string().min(1).max(100) }),
  z.strictObject({
    provider: z.literal('deepseek'),
    url: z.url(),
    model: z.string().min(1).max(100),
    probePassed: z.boolean().default(false),
  }),
]);
export const SmartPasteInstallationSchema = z
  .strictObject({
    installationId: z.string().min(1).max(200),
    consent: z.strictObject({
      granted: z.boolean(),
      at: z.iso.date().nullable(),
      basis: z.string().max(1000),
    }),
    providers: z.array(SmartPasteProviderSchema).max(2),
  })
  .refine((v) => new Set(v.providers.map((p) => p.provider)).size === v.providers.length);
export type SmartPasteInstallation = z.infer<typeof SmartPasteInstallationSchema>;
